module.exports = __webpack_public_path__ + "static/img/17018B_1_R_20201021_LC.b794e6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/17018B_1_R_20201021_LC.png
// module id = UtA+
// module chunks = 0